import { render, staticRenderFns } from "./OaBusinessFields.vue?vue&type=template&id=33227732&scoped=true"
import script from "./OaBusinessFields.vue?vue&type=script&lang=js"
export * from "./OaBusinessFields.vue?vue&type=script&lang=js"
import style0 from "./OaBusinessFields.vue?vue&type=style&index=0&id=33227732&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33227732",
  null
  
)

export default component.exports